import React from "react";
import {
  TextInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  SelectInput,
} from "react-admin";
import { MyCreate } from "../../_myBase/components/myMutator";

const typeChoices = [
  { id: "DISCOUNT", name: "Discount" },
  { id: "SURCHARGE", name: "Surcharge" },
];

export default function DiscountPlanCreate(props) {
  return (
    <MyCreate {...props}>
      <TextInput source="name" />
      <BooleanInput source="isDefault" label="Set as default" />
      <ArrayInput source="brackets">
        <SimpleFormIterator inline>
          <NumberInput source="minDays" label="Min Days" />
          <SelectInput source="type" choices={typeChoices} />
          <NumberInput source="percentage" label="%" />
        </SimpleFormIterator>
      </ArrayInput>
    </MyCreate>
  );
}
